<template>
  <section>
    <Title title="Cozinha">
      <h2 class="mb-0"><span class="badge bg-info-soft">{{ `${this.orders_filtered.filter(item => item.status == 'confirmed').length} / ${this.orders_filtered.filter(item => item.status == 'processing').length}` }}</span></h2>
    </Title>

    <div v-if="orders_filtered.length > 0" class="row justify-content-center align-items-center">
      <KitchenCard v-for="order in orders_filtered" :key="order.id" :order="order" />
    </div>
    <div v-else class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-6 text-center">
        <i class="fas fa-times-circle display-1 mb-3"></i>
        <h2>Nenhum pedido ainda</h2>
      </div>
    </div>
  </section>
</template>

<script>
// import Select from '../components/Input/Select'
import Title from '../components/Header/Title'
import KitchenCard from '../components/Kitchen/Card'

export default {
  name: 'Kitchen',
  components: {
    // Select,
    Title,
    KitchenCard,
  },
  data() {
    return {
    }
  },
  computed: {
    orders_filtered() {
      return this.$store.state.orders.itens.filter(item => item.status == 'processing' || item.status == 'confirmed');
    }
  },
  methods: {
    getOrders() {
      this.$store.dispatch('orders/updateOrders');
    }
  },
  mounted() {
    this.getOrders();

    this.interval = setInterval(this.getOrders, 10000);
  },
  destroyed() {
    clearInterval(this.interval);
  }
}
</script>
